// src/components/molecules/SubmissionDetails/SubmissionTitleSection.js

import React from "react";
import { Box, Link, Typography } from "@mui/material";

const SubmissionTitleSection = ({ submissionDetails, theme }) => {

  console.log('SubmissionTitleSection: challenge: ', submissionDetails);
  return (
    <Box sx={{ mb: 4 }}>
      <Link
        href={`/challenge/submissions/all/${submissionDetails.challengeId}`}
        underline="none"
        sx={{
          fontFamily: "basic-sans",
          fontSize: "1.2em",
          fontWeight: 500,
          color: theme.colors.red,
          cursor: "pointer",
          display: "block",
          textAlign: "center",
          mb: 4,
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        All "{submissionDetails.challengeData.title}" Submissions
      </Link>

      <Typography
        variant="h4"
        component="h1"
        align="center"
        sx={{
          fontFamily: "basic-sans",
          fontWeight: 700,
          mb: 2,
          "& span": {
            color: theme.colors.darkGray,
            fontWeight: "normal",
          },
        }}
      >
        "{submissionDetails.challengeData.title}" <span>Submission</span>
      </Typography>
    </Box>
  );
};

export default SubmissionTitleSection;
